module.exports = __webpack_public_path__ + "img/photo01.75c3a912.jpg";